function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("a", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "20",
  cy: "20",
  r: "19.5",
  fill: "#FFF",
  stroke: "#545454",
  className: styles["close-icon-background"] || "close-icon-background"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.243 15.757c.189.19.21.484.063.696l-.063.076-3.472 3.47 3.472 3.472a.546.546 0 01-.696.835l-.076-.063L20 20.77l-3.471 3.472a.546.546 0 01-.835-.696l.063-.076L19.23 20l-3.472-3.47a.546.546 0 01.696-.835l.076.063L20 19.227l3.471-3.47a.546.546 0 01.772 0z",
  fill: "#0F0F0F"
}))));